<mat-card>
  <mat-card-title
    [ngStyle]="{ visibility: isEditingUserDetails ? 'hidden' : 'visible' }">
    <div class="options-wrapper text-right">
      <button
        mat-icon-button
        #trigger="matMenuTrigger"
        [matMenuTriggerFor]="menu">
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="toggleIsEditingUserDetails()">
          <mat-icon>edit</mat-icon> {{ "operations.edit" | transloco }}
        </button>
      </mat-menu>
    </div>
  </mat-card-title>

  @if(!isEditingUserDetails) { @for(field of userDetailsFormModel.formFields;
  track field) {
  <loren-key-value [key]="field.label" [value]="field.value"> </loren-key-value>
  } } @else {
  <loren-entity-form
    #form
    [formModel]="userDetailsFormModel"
    (submitForm)="handleFormSubmit($event)">
  </loren-entity-form>
  <div class="mt-3 vertically-centered" style="gap: 8px">
      <button
              matButton="filled"
              class="btn-secondary"
              (click)="toggleIsEditingUserDetails()">
          {{ "operations.cancel" | transloco }}
      </button>
    <button matButton="filled" (click)="form.onSubmit()">
      {{ "operations.save" | transloco }}
    </button>
  </div>
  }
</mat-card>
